import axios from 'axios';
import store from '../redux/store';
import { User } from '../interfaces/api/user';
import { fetchUserThunk } from '../redux/slicers/authenticationSlice';
import { fetchOrganizationsThunk, selectOrganization } from '../redux/slicers/organizationSlice';
import { fetchBuildingsSearchFilterThunk, selectBuilding } from '../redux/slicers/buildingSlice';
import { Organization } from '../interfaces/api/organization';
import { fetchFloorSearchFilterThunk } from '../redux/slicers/floorSlice';
import { Building } from '../interfaces/api/building';
import { fetchRoomSearchFilterThunk } from '../redux/slicers/roomSlice';
import Cookies from 'js-cookie';
import { fetchTagSearchFilterThunk } from '../redux/slicers/tagSlice';
import { fetchModalitiesThunk } from '../redux/slicers/modalitySlice';

async function initializeUser(): Promise<User | undefined> {
	const token = Cookies.get('Token');
	if (token) {
		const parsedToken = JSON.parse(token);
		axios.defaults.headers.common['Authorization'] = `Token ${parsedToken.token}`;
		const user = await store.dispatch(fetchUserThunk());
		return user.payload as User;
	}
	return undefined;
}

async function initializeData(user: User, withToken: boolean): Promise<boolean> {
	try {
		const organizations = await store.dispatch(fetchOrganizationsThunk());
		const buildings = await store.dispatch(
			fetchBuildingsSearchFilterThunk({
				params: { organization: String((organizations.payload as Organization[])[0].id) },
			})
		);
		if (
			organizations.payload &&
			(organizations.payload as Organization[]).length > 0 &&
			buildings.payload &&
			(buildings.payload as Building[]).length > 0
		) {
			await store.dispatch(selectOrganization((organizations.payload as Organization[])[0].id));
			await store.dispatch(selectBuilding((buildings.payload as Building[])[0].id));
			await store.dispatch(
				fetchFloorSearchFilterThunk({
					params: {
						building: String((buildings.payload as Building[])[0].id),
						building__organization: String((organizations.payload as Organization[])[0].id),
					},
				})
			);
			await store.dispatch(
				fetchRoomSearchFilterThunk({
					params: {
						floor__building: String((buildings.payload as Building[])[0].id),
						floor__building__organization: String((organizations.payload as Organization[])[0].id),
					},
				})
			);
			await store.dispatch(
				fetchTagSearchFilterThunk({
					params: {
						device__building: String((buildings.payload as Building[])[0].id),
						device__organization: String((organizations.payload as Organization[])[0].id),
					},
				})
			);
			await store.dispatch(fetchModalitiesThunk());
		}
		return true;
	} catch (e) {
		return false;
	}
}

const initialization = {
	initializeUser,
	initializeData,
};

export default initialization;
